import React from 'react';

/**
 * Componente indicador de pasos del wizard
 * Muestra el progreso visual del usuario a través del formulario de múltiples pasos
 */
const StepIndicator = ({ currentStep, totalSteps = 4 }) => {
  const steps = [
    { number: 1, title: 'Información Básica' },
    { number: 2, title: 'Configuración' },
    { number: 3, title: 'Preguntas' },
    { number: 4, title: 'Revisión' }
  ];

  return (
    <>
      <div className="step-indicator mb-4">
        <div className="d-flex justify-content-between mb-3">
          {steps.map((step) => (
            <div key={step.number} className="text-center flex-fill">
              <div
                className={`step-circle ${
                  currentStep >= step.number ? 'active' : 'inactive'
                }`}
              >
                {step.number}
              </div>
              <div className="step-title mt-2">{step.title}</div>
            </div>
          ))}
        </div>
        <div className="progress">
          <div
            className="progress-bar bg-primary"
            style={{ width: `${(currentStep / totalSteps) * 100}%` }}
          ></div>
        </div>
      </div>

      {/* Estilos CSS en línea para evitar dependencias externas */}
      <style>{`
        .step-indicator .step-circle {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: inline-flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          margin: 0 auto;
        }
        
        .step-circle.active {
          background-color: #0d6efd;
          color: white;
        }
        
        .step-circle.inactive {
          background-color: #e9ecef;
          color: #6c757d;
          border: 2px solid #dee2e6;
        }
        
        .step-title {
          font-size: 0.875rem;
          color: #6c757d;
          font-weight: 500;
        }
      `}</style>
    </>
  );
};

export default StepIndicator;